//constants
import {BIDS, CONTRIBUTIONS, PROFILE} from '@/utils/constants';
//types
import {IOrganizationAttendee} from '@/utils/types';
import {AttendeeDetailsFormValues} from './formConfiguration';

export enum ATTENDEE_DETAILS_TABS {
	PROFILE = 'Profile',
	BIDS = 'Bids',
	CONTRIBUTIONS = 'Contributions',
}

export const attendeeDetailsTabs = [PROFILE, BIDS, CONTRIBUTIONS];

export const getAttendeeInitialValues = (attendee: IOrganizationAttendee): AttendeeDetailsFormValues => {
	const {
		id,
		userInfo: {email, firstName, lastName, phoneNumber, address, city, state, zip, meals},
	} = attendee;

	return {
		id,
		email,
		firstName,
		lastName,
		phoneNumber,
		address: address || '',
		city: city || '',
		state: state || '',
		zip: zip || '',
		meals,
	};
};
